import { type ReactNode } from 'react';
import { HeaderNotifications } from './HeaderNotifications';
import { HeaderAlerts } from './HeaderAlerts';
import { HeaderUserMenu } from './HeaderUserMenu';

interface HeaderActionsProps {
  timerSlot?: ReactNode;
}

export function HeaderActions({ timerSlot }: HeaderActionsProps) {
  return (
    <div className="flex items-center gap-1">
      {timerSlot}
      <HeaderNotifications />
      <HeaderAlerts />
      <HeaderUserMenu />
    </div>
  );
}
